import React, { useEffect, useState, useCallback } from "react";
import {
  Button,
  message,
  Input,
  Modal,
  Cascader,
  Icon,
  Radio,
  Spin,
} from "antd";
import "./index.less";
import loadmap from "../AMap/loadmap.js";
import loadScript from "../../utils/loadScript.js";
import config from "../../../config";
const { Search } = Input;
const str = (v) => (typeof v === "string" ? v : "");
const Map = ({ onLoad, minZoom = 11, center, onClick }) => {
  useEffect(() => {
    let map = new window.AMap.Map("Mapcontainer", {
      // rotateEnable: false,
      doubleClickZoom: false,
      zoom: minZoom,
      center: center || [112.224499, 31.054108],
      pitch: 0,
      // zooms: [minZoom, 15],
      // mapStyle: "amap://styles/ab2764e020b7c508783211f830aaeaae" //设置地图的显示样式
    });

    const handleClick = (e) => {
      if (typeof onClick === "function") {
        onClick([e.lnglat.getLng(), e.lnglat.getLat()], map);
      }
    };
    map.on("click", handleClick);

    onLoad(map);
    return () => {
      map.off("click", handleClick);
    };
  }, []);

  return <div id="Mapcontainer" style={{ width: "100%", height: "100%" }} />;
};
const MapBox = ({ visible, onSave, onClose, info }) => {
  const [map, setMap] = useState();
  const [geocoder, setGecoder] = useState();
  const [marker, setMarker] = useState();
  const [pos, setPos] = useState({});
  const [type, setType] = useState(1);
  const [lngLat, setLngLat] = useState();

  useEffect(() => {
    var geo = new AMap.Geocoder({
      city: "010", //城市设为北京，默认：“全国”
      radius: 1000, //范围，默认：500
    });
    var marker = new AMap.Marker();
    setMarker(marker);
    setGecoder(geo);
  }, []);
  useEffect(() => {
    if (!map) return;
    var autoOptions = {
      input: "MapSearch",
    };

    var auto = new AMap.Autocomplete(autoOptions);
    var placeSearch = new AMap.PlaceSearch({
      map: map,
    }); //构造地点查询类
    AMap.event.addListener(auto, "select", select); //注册监听，当选中某条记录时会触发
    function select(e) {
      placeSearch.setCity(e.poi.adcode);
      placeSearch.search(e.poi.name, () => {
        console.log(placeSearch);
        try {
          placeSearch.render.markerList.clear();
        } catch (e) {}
      }); //关键字查询查询
    }
  }, [map, type]);
  useEffect(() => {
    info && setPos(info);
  }, [info]);
  useEffect(() => {
    if (map && marker && pos.longitude && pos.latitude) {
      map.setCenter([pos.longitude, pos.latitude]);
      map.add(marker);
      marker.setPosition([pos.longitude, pos.latitude]);
    }
  }, [map, marker, pos.longitude, pos.latitude]);

  const getAddressByLngLat = (lnglat) => {
    console.log("查询坐标---", lnglat);
    geocoder.getAddress(lnglat, function (status, result) {
      if (status === "complete" && result.regeocode) {
        const { addressComponent, formattedAddress } = result.regeocode;
        const { province, city, district } = addressComponent;
        setPos({
          longitude: lnglat[0],
          latitude: lnglat[1],
          province: str(province),
          city: str(city),
          district: str(district),
          position: `${formattedAddress}`.replace(
            [province, city, district].join(""),
            ""
          ),
        });
      } else {
        setPos({
          longitude: undefined,
          latitude: undefined,
          province: undefined,
          city: undefined,
          district: undefined,
          position: undefined,
        });
        message.error("根据经纬度查询地址失败");
      }
    });
  };

  const handleClick = useCallback(
    (lnglat, map) => {
      if (!map) return;
      map.add(marker);
      marker.setPosition(lnglat);
      getAddressByLngLat(lnglat);
    },
    [geocoder]
  );

  const onTypeChange = (e) => {
    setType(e.target.value);
    if (e.target.value == 2) {
      const { longitude, latitude } = pos;
      if (!longitude || !latitude || isNaN(longitude) || isNaN(latitude)) {
        return;
      }
      setLngLat(`${longitude},${latitude}`);
    }
  };

  const onSearchLngLat = (val) => {
    if (!val) {
      message.error("请输入坐标对");
      return;
    }
    if (!/^(\d+[.]?\d+),(\d+[.]?\d+)$/.test(val)) {
      message.error("输入坐标对错误");
      return;
    }
    setLngLat(val);
    let lnglat = val.indexOf(",") != -1 ? val.split(",") : [];
    getAddressByLngLat(lnglat);
  };

  const onChangeLngLat = (e) => {
    setLngLat(e.target.value);
  };

  const { province, city, district, position, longitude, latitude } = pos;
  return (
    <Modal
      title="获取位置"
      visible={visible}
      onCancel={onClose}
      destroyOnClose={true}
      width={1000}
      maskClosable={false}
      footer={[
        <Button key="close" onClick={onClose}>
          关闭
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={() => {
            if (!pos.longitude || !pos.latitude) {
              message.error("请选点击地图择经纬度");
              return;
            }
            if (!pos.position) {
              message.error("请输入详细地址");
              return;
            }
            onSave(pos);
            onClose();
          }}
        >
          确定
        </Button>,
      ]}
    >
      <div className={"TUI-LocationSelect"}>
        <div>
          <div className={"TUI-LocationSelect-RadioSty"}>
            <span>查询条件: </span>
            <Radio.Group onChange={onTypeChange} value={type}>
              <Radio value={1}>按关键字搜索</Radio>
              <Radio value={2}>按坐标搜索</Radio>
            </Radio.Group>
          </div>
          {type == 1 ? (
            <div className={"TUI-LocationSelect-Search"}>
              <span>搜索位置: </span>
              <span>
                <Input id="MapSearch" />
              </span>
            </div>
          ) : (
            <div
              className={`${"TUI-LocationSelect-Search"} ${"TUI-LocationSelect-Search2"}`}
            >
              <span>搜索位置: </span>
              <span>
                <Search
                  value={lngLat}
                  onChange={onChangeLngLat}
                  onSearch={onSearchLngLat}
                  placeholder="请输入坐标对，如 112.3,30.8"
                  enterButton
                />
              </span>
            </div>
          )}
          <div className={"TUI-LocationSelect-Ctrl"}>
            <span>行政区位: </span>
            <span
              className={"TUI-LocationSelect-Pos"}
              title={[province, city, district].filter((d) => !!d).join("/")}
            >
              {[province, city, district].filter((d) => !!d).join("/")}
            </span>
            <span>
              <Input
                value={position}
                onChange={(e) => {
                  setPos({
                    ...pos,
                    position: e.target.value,
                  });
                }}
              />
            </span>
            <span className={"TUI-LocationSelect-Submit"}></span>
            <span className={"TUI-LocationSelect-Lng"}>
              经度：
              {longitude}
            </span>
            <span>
              纬度：
              {latitude}
            </span>
          </div>
        </div>
        <div>
          <Map onLoad={setMap} onClick={handleClick} />
        </div>
      </div>
    </Modal>
  );
};
const _getValue = (fields) => {
  const { longitude, latitude, position, province, city, district, loading } =
    fields;
  return {
    longitude,
    latitude,
    position,
    province,
    city,
    district,
    loading,
  };
};
export const onCityChange = (value, onChange) => {
  const { longitude, latitude, position, province, city, district, loading } =
    value || {};
  onChange({
    longitude,
    latitude,
    province,
    city,
    district,
    position,
    loading,
  });
};

const CitySelect = ({ onChange, fields, opts = {} }) => {
  const { getValue = _getValue, disabled, cascDisabled = false } = opts;
  const [visible, setVisible] = useState(false);
  const [cityOptions, setCityOptions] = useState([]);
  const value = typeof getValue === "function" ? getValue(fields) : {};
  const { province, city, district, position, loading = false } = value;
  useEffect(() => {
    loadmap();
    loadScript(
      config.CITY_DATA,
      () => !!window.tui_cityOptions,
      () => {
        setCityOptions(window.tui_cityOptions);
      }
    );
  }, []);
  if (!window.AMap) return null;
  return (
    <>
      <Input.Group compact>
        <Cascader
          style={{ width: "40%" }}
          value={[province, city, district]}
          options={cityOptions}
          disabled={disabled || cascDisabled}
          onChange={(val) =>
            onChange({
              ...value,
              province: val[0],
              city: val[1],
              district: val[2],
            })
          }
        />
        <Input
          value={position}
          onChange={(e) => onChange({ ...value, position: e.target.value })}
          disabled={disabled}
          style={{ width: disabled ? "60%" : "50%" }}
        />
        {disabled ? null : (
          <a
            style={{ width: "10%", padding: "4px 0 4px 8px" }}
            onClick={() => setVisible(true)}
          >
            {loading ? (
              <Spin
                indicator={
                  <Icon type="loading" style={{ fontSize: 16 }} spin />
                }
              />
            ) : (
              <Icon type="environment" />
            )}
          </a>
        )}
      </Input.Group>
      {visible ? (
        <MapBox
          visible={visible}
          onClose={() => setVisible(false)}
          onSave={onChange}
          info={value}
        />
      ) : null}
    </>
  );
};

export default CitySelect;
